import {
  Fragment,
  KeyboardEventHandler,
  ReactNode,
  useEffect,
  useRef,
  useState
} from 'react'
import { createGuid } from '../../../map_utils/index'
import AccordionContent from './AccordionContent'
import { AccordionSectionType } from '../../../interfaces/index'

const AccordionSection = ({
  index,
  id,
  label,
  count,
  content,
  isOpen,
  setIsOpen,
  setLocation,
  scrollToMap
}: AccordionSectionType) => {
  const [isSectionOpen, setIsSectionOpen] = useState<boolean>(isOpen)
  const refContainer = useRef(null)
  const [maxHeight, setMaxHeight] = useState(0)
  const isEven = Number(index) % 2 !== 0
  const btnClass = `wc-outages__accordion__button${isOpen ? ' wc-outages__accordion__button--is-open' : ''}${isEven ? ' wc-outages__accordion--alt' : ''}`;
  const contentClass = `wc-outages__accordion__content${isEven ? ' wc-outages__accordion--alt' : ''}`
  const containerClass = 'wc-outages__accordion__container'

  // Create content items
  const items: Array<ReactNode> = content.reduce(
    (arrayOfItems: Array<ReactNode>, currentItem: any) => {
      const newLocal = (
        <div key={createGuid()}>
          <AccordionContent
            content={currentItem.content}
            setLocation={setLocation}
            scrollToMap={scrollToMap}
          />
        </div>
      )
      return [...arrayOfItems, newLocal]
    },
    []
  )

  // Set the max height of accordion
  useEffect(() => {
    if (refContainer?.current && isSectionOpen) {
      // @ts-ignore
      setMaxHeight(refContainer?.current.scrollHeight)
    } else {
      setMaxHeight(0)
    }
  }, [refContainer, isSectionOpen])

  // Function to handle the key press
  const handleKeyPressOpen = (e: KeyboardEventHandler<HTMLButtonElement>) => {
    // @ts-ignore
    if (e.key === 13 || e.key === 32) {
      setIsSectionOpen(!isSectionOpen)
      setIsOpen(!isSectionOpen)
      // @ts-ignore
    } else if (e.key === 27) {
      setIsSectionOpen(false)
      setIsOpen(false)
    }
  }

  return (
    <Fragment key={createGuid()}>
      <h4 className="wc-outages__accordion__title">
        <button
          className={btnClass}
          aria-controls={`wc-outages__accordion-content-${id}`}
          aria-expanded={isSectionOpen}
          id={`wc-outages__accordion-control-${id}`}
          onClick={() => {
            setIsSectionOpen(!isSectionOpen)
            setIsOpen(!isSectionOpen)
          }}
          // @ts-ignore
          onKeyDown={handleKeyPressOpen}
        >
          <h4 className="h5 wc-outages__accordion__title">{label}</h4>
          <div>
            <p className="wc-outages__accordion__count">({count})</p>
          </div>
        </button>
      </h4>
      <div
        className={contentClass}
        ref={refContainer}
        style={{ maxHeight: maxHeight }}
        aria-hidden={!isOpen}
        id={`wc-outages__accordion-content-${id}`}
      >
        <div className={containerClass}>{items}</div>
      </div>
    </Fragment>
  )
}

export default AccordionSection
